import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@doxyme/ui';
export const DisclaimerModal = ({ isOpen, onClose, onContinue, videoSource, }) => {
    return (<Modal ariaLabelledby="disclaimer-modal-title" isOpen={isOpen} isSmall closeModal={onClose}>
      <ModalHeader onClose={onClose}>
        <h4 id="disclaimer-modal-title">
          <FormattedMessage id="patient.disclaimer-modal.title"/>
        </h4>
      </ModalHeader>
      <ModalBody>
        <FormattedMessage id="patient.disclaimer-modal.text" values={{ videoSource }}/>
      </ModalBody>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button size="medium" btnStyle="outline" color="secondary" onClick={onClose}>
            <FormattedMessage id="patient.disclaimer-modal.cancel"/>
          </Button>
          <Button size="medium" onClick={onContinue}>
            <FormattedMessage id="patient.disclaimer-modal.continue"/>
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
